(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8c83"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8c83"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});


parcelRegister("1MMdM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $14cfaddf7b657fa6$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "whenGlobal", function () { return $14cfaddf7b657fa6$export$42a7c3ec3c3dde5a; });
$parcel$export(module.exports, "documentSignal", function () { return $14cfaddf7b657fa6$export$5b0c92123667125b; });
// Runs a block initializer on the frontend (once the DOM is ready) or after
// every ACF preview render in the editor. The initializer receives the root
// to search in and `{ isEditor }`.
function $14cfaddf7b657fa6$export$2e2bcd8739ae039(slug, init) {
    var acf = window.acf, wp = window.wp;
    if ((acf === null || acf === void 0 ? void 0 : acf.addAction) && (wp === null || wp === void 0 ? void 0 : wp.blocks)) {
        acf.addAction("render_block_preview/type=".concat(slug), function($block) {
            var root = ($block === null || $block === void 0 ? void 0 : $block.jquery) ? $block.get(0) : $block;
            if (root) init(root, {
                isEditor: true
            });
        });
        return;
    }
    var run = function() {
        return init(document, {
            isEditor: false
        });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
    else run();
}
function $14cfaddf7b657fa6$export$42a7c3ec3c3dde5a(win, name, callback) {
    if (win[name]) {
        callback(win[name]);
        return;
    }
    win.addEventListener('load', function() {
        if (win[name]) callback(win[name]);
    }, {
        once: true
    });
}
function $14cfaddf7b657fa6$export$5b0c92123667125b(doc, key, instance) {
    var _instance_closest, _store_get;
    var store = doc.juniperBlockSignals || new Map();
    // eslint-disable-next-line no-param-reassign
    doc.juniperBlockSignals = store;
    var id = instance ? "".concat(key, ":").concat(((_instance_closest = instance.closest('[data-block]')) === null || _instance_closest === void 0 ? void 0 : _instance_closest.dataset.block) || '') : key;
    (_store_get = store.get(id)) === null || _store_get === void 0 ? void 0 : _store_get.abort();
    var controller = new AbortController();
    store.set(id, controller);
    return controller.signal;
}

});

function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $2Xzd1 = parcelRequire("2Xzd1");
function $e73bd16ec0b3c415$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}



var $1MMdM = parcelRequire("1MMdM");
function $03c0497b5da76e78$var$initDocCenter(root) {
    var block = root.querySelector('.doc-center');
    var list = block === null || block === void 0 ? void 0 : block.querySelector('#doc-center-list');
    if (!list || list.dataset.runtimeReady === 'true') return;
    list.dataset.runtimeReady = 'true';
    var ownerDoc = block.ownerDocument;
    var signal = (0, $1MMdM.documentSignal)(ownerDoc, 'documentation-center');
    var loading = block.querySelector('#doc-center-loading');
    var empty = block.querySelector('#doc-center-empty');
    var moreBtn = block.querySelector('#doc-center-more');
    var searchEl = block.querySelector('#doc-center-search');
    var activeBar = block.querySelector('#doc-center-active-filters');
    var tagsEl = block.querySelector('#doc-center-tags');
    var clearAllBtn = block.querySelector('#doc-center-clear-all');
    var dropdowns = block.querySelectorAll('.doc-center__dropdown');
    var _ref = window.docCenterData || {}, restUrl = _ref.restUrl, _ref_perPage = _ref.perPage, perPage = _ref_perPage === void 0 ? 20 : _ref_perPage;
    var page = 1;
    var fetching = false;
    var controller = null;
    var generation = 0;
    // ── Mobile filter sheet ────────────────────────────────────────────────
    var filterToggle = block.querySelector('#doc-center-filter-toggle');
    var filtersPanel = block.querySelector('#doc-center-filters');
    var filterClose = block.querySelector('#doc-center-filter-close');
    var overlay = block.querySelector('#doc-center-overlay');
    var openFilters = function() {
        filterToggle === null || filterToggle === void 0 ? void 0 : filterToggle.setAttribute('aria-expanded', 'true');
        filtersPanel === null || filtersPanel === void 0 ? void 0 : filtersPanel.classList.add('is-open');
        overlay === null || overlay === void 0 ? void 0 : overlay.classList.add('is-open');
        ownerDoc.body.style.overflow = 'hidden';
    };
    var closeFilters = function() {
        filterToggle === null || filterToggle === void 0 ? void 0 : filterToggle.setAttribute('aria-expanded', 'false');
        filtersPanel === null || filtersPanel === void 0 ? void 0 : filtersPanel.classList.remove('is-open');
        overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove('is-open');
        ownerDoc.body.style.overflow = '';
    };
    filterToggle === null || filterToggle === void 0 ? void 0 : filterToggle.addEventListener('click', function() {
        filterToggle.getAttribute('aria-expanded') === 'true' ? closeFilters() : openFilters();
    });
    filterClose === null || filterClose === void 0 ? void 0 : filterClose.addEventListener('click', closeFilters);
    overlay === null || overlay === void 0 ? void 0 : overlay.addEventListener('click', closeFilters);
    // ── Dropdown toggle ────────────────────────────────────────────────────
    var closeAll = function() {
        dropdowns.forEach(function(dd) {
            var _dd_querySelector, _dd_querySelector1;
            (_dd_querySelector = dd.querySelector('.doc-center__dropdown-btn')) === null || _dd_querySelector === void 0 ? void 0 : _dd_querySelector.setAttribute('aria-expanded', 'false');
            (_dd_querySelector1 = dd.querySelector('.doc-center__dropdown-panel')) === null || _dd_querySelector1 === void 0 ? void 0 : _dd_querySelector1.setAttribute('hidden', '');
        });
    };
    dropdowns.forEach(function(dd) {
        var btn = dd.querySelector('.doc-center__dropdown-btn');
        var panel = dd.querySelector('.doc-center__dropdown-panel');
        btn === null || btn === void 0 ? void 0 : btn.addEventListener('click', function() {
            var isOpen = btn.getAttribute('aria-expanded') === 'true';
            closeAll();
            if (!isOpen) {
                btn.setAttribute('aria-expanded', 'true');
                panel === null || panel === void 0 ? void 0 : panel.removeAttribute('hidden');
            }
        });
        panel === null || panel === void 0 ? void 0 : panel.querySelectorAll('.doc-center__checkbox').forEach(function(cb) {
            cb.addEventListener('change', function() {
                updateDropdownLabel(dd);
                updateActiveTags();
                reset();
            });
        });
    });
    ownerDoc.addEventListener('click', function(e) {
        if (!e.target.closest('.doc-center__dropdown')) closeAll();
    }, {
        signal: signal
    });
    ownerDoc.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') closeAll();
    }, {
        signal: signal
    });
    // ── Dropdown label (e.g. "All product lines (2)") ──────────────────────
    var updateDropdownLabel = function(dd) {
        var label = dd.querySelector('.doc-center__dropdown-label');
        var defaultText = dd.dataset.defaultLabel || '';
        var checked = dd.querySelectorAll('.doc-center__checkbox:checked');
        if (label) label.textContent = checked.length ? "".concat(defaultText, " (").concat(checked.length, ")") : defaultText;
    };
    // ── Active filters tags ────────────────────────────────────────────────
    var updateActiveTags = function() {
        if (!tagsEl || !activeBar) return;
        tagsEl.innerHTML = '';
        var total = 0;
        dropdowns.forEach(function(dd) {
            var filter = dd.dataset.filter;
            dd.querySelectorAll('.doc-center__checkbox:checked').forEach(function(cb) {
                total++;
                var li = ownerDoc.createElement('li');
                var tag = ownerDoc.createElement('button');
                tag.type = 'button';
                tag.className = 'doc-center__tag';
                tag.appendChild(ownerDoc.createTextNode(cb.dataset.label || cb.value));
                var x = ownerDoc.createElement('span');
                x.setAttribute('aria-hidden', 'true');
                x.textContent = "\xd7";
                tag.appendChild(x);
                tag.addEventListener('click', function() {
                    cb.checked = false;
                    updateDropdownLabel(dd);
                    updateActiveTags();
                    reset();
                });
                li.appendChild(tag);
                tagsEl.appendChild(li);
            });
        });
        activeBar.hidden = total === 0;
    };
    clearAllBtn === null || clearAllBtn === void 0 ? void 0 : clearAllBtn.addEventListener('click', function() {
        dropdowns.forEach(function(dd) {
            dd.querySelectorAll('.doc-center__checkbox:checked').forEach(function(cb) {
                cb.checked = false;
            });
            updateDropdownLabel(dd);
        });
        updateActiveTags();
        reset();
    });
    // ── Build query params ─────────────────────────────────────────────────
    var getFilters = function() {
        var params = new URLSearchParams({
            page: page,
            per_page: perPage
        });
        var q = searchEl === null || searchEl === void 0 ? void 0 : searchEl.value.trim();
        if (q) params.set('s', q);
        dropdowns.forEach(function(dd) {
            var filter = dd.dataset.filter;
            var checked = (0, $2Xzd1._)(dd.querySelectorAll('.doc-center__checkbox:checked'));
            checked.forEach(function(cb) {
                return params.append("".concat(filter, "[]"), cb.value);
            });
        });
        return params;
    };
    // ── Render rows ────────────────────────────────────────────────────────
    var iconSvg = function(path, title) {
        return '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" role="img" aria-label="'.concat(title, '">\n      <title>').concat(title, '</title>\n      <path stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="').concat(path, '"/>\n    </svg>');
    };
    var eyePath = 'M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8zM12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z';
    var downloadPath = 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5 5 5-5M12 15V3';
    var safeUrl = function(url) {
        try {
            var protocol = new URL(url).protocol;
            return protocol === 'http:' || protocol === 'https:' ? url : '';
        } catch (e) {
            return '';
        }
    };
    var renderItem = function(doc) {
        var _doc_product_line;
        var li = ownerDoc.createElement('li');
        li.className = 'doc-center__row';
        var nameSpan = ownerDoc.createElement('span');
        nameSpan.className = 'doc-center__doc-name';
        nameSpan.textContent = doc.title || '';
        var lineSpan = ownerDoc.createElement('span');
        lineSpan.className = 'doc-center__line-cell';
        if ((_doc_product_line = doc.product_line) === null || _doc_product_line === void 0 ? void 0 : _doc_product_line.name) {
            var iconSrc = safeUrl(doc.product_line.icon_url || '');
            if (iconSrc) {
                var img = ownerDoc.createElement('img');
                img.src = iconSrc;
                img.alt = '';
                img.className = 'doc-center__line-icon';
                img.width = 20;
                img.height = 20;
                img.loading = 'lazy';
                lineSpan.appendChild(img);
            }
            var nameEl = ownerDoc.createElement('span');
            nameEl.textContent = doc.product_line.name;
            lineSpan.appendChild(nameEl);
        } else lineSpan.textContent = "\u2014";
        var typeSpan = ownerDoc.createElement('span');
        typeSpan.className = 'doc-center__type-cell';
        typeSpan.textContent = doc.document_type || "\u2014";
        var actionsSpan = ownerDoc.createElement('span');
        actionsSpan.className = 'doc-center__actions';
        var fileUrl = safeUrl(doc.file_url || '');
        var viewLink = ownerDoc.createElement('a');
        if (fileUrl) viewLink.href = fileUrl;
        viewLink.target = '_blank';
        viewLink.rel = 'noopener noreferrer';
        viewLink.className = 'doc-center__action';
        viewLink.innerHTML = iconSvg(eyePath, 'View');
        actionsSpan.appendChild(viewLink);
        if (!doc.is_external && fileUrl) {
            var dlLink = ownerDoc.createElement('a');
            dlLink.href = fileUrl;
            dlLink.download = '';
            dlLink.className = 'doc-center__action';
            dlLink.innerHTML = iconSvg(downloadPath, 'Download');
            actionsSpan.appendChild(dlLink);
        }
        li.appendChild(nameSpan);
        li.appendChild(lineSpan);
        li.appendChild(typeSpan);
        li.appendChild(actionsSpan);
        return li;
    };
    // ── Fetch ──────────────────────────────────────────────────────────────
    var setLoading = function(state) {
        fetching = state;
        if (loading) loading.hidden = !state;
        if (moreBtn) moreBtn.disabled = state;
    };
    var fetch_ = function() {
        var append = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $554ed4b40b13e16f$export$71511d61b312f219)(function() {
            var thisGen, _data_items, res, data, frag, e;
            return (0, $e73bd16ec0b3c415$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        generation++;
                        thisGen = generation;
                        controller === null || controller === void 0 ? void 0 : controller.abort();
                        controller = new AbortController();
                        setLoading(true);
                        if (empty) empty.hidden = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            fetch("".concat(restUrl, "?").concat(getFilters()), {
                                signal: controller.signal
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 3:
                        data = _state.sent();
                        if (thisGen !== generation) return [
                            2
                        ];
                        if (!append) list.innerHTML = '';
                        if (!((_data_items = data.items) === null || _data_items === void 0 ? void 0 : _data_items.length) && !append) {
                            if (empty) empty.hidden = false;
                        } else {
                            frag = ownerDoc.createDocumentFragment();
                            (data.items || []).forEach(function(doc) {
                                return frag.appendChild(renderItem(doc));
                            });
                            list.appendChild(frag);
                        }
                        if (moreBtn) moreBtn.hidden = !data.has_more;
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        if (e.name !== 'AbortError') console.error('[doc-center]', e);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        if (thisGen === generation) setLoading(false);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    };
    var reset = function() {
        page = 1;
        fetch_(false);
    };
    var debounceTimer;
    searchEl === null || searchEl === void 0 ? void 0 : searchEl.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(reset, 300);
    });
    moreBtn === null || moreBtn === void 0 ? void 0 : moreBtn.addEventListener('click', function() {
        page++;
        fetch_(true);
    });
    fetch_(false);
}
(0, $1MMdM.default)('documentation-center', $03c0497b5da76e78$var$initDocCenter);

})();
//# sourceMappingURL=script.js.map
